import { AppLayoutContainer } from '@zg-rentals/zrm-header-navigation';
import Link from 'next/link';
import { useAuth } from '../../AuthProvider';

const host = typeof window !== 'undefined' && window !== null ? window.location.host : 'www.zillow.com';

export const ZRAMPageLayout = ({ children }: { children: React.ReactNode }) => {
  const pathname = typeof window !== 'undefined' && window !== null ? window.location.href : '';

  const { user } = useAuth();

  if (!user) return null;

  return (
    <AppLayoutContainer
      host={host}
      pathname={pathname}
      brand="zillow"
      userModel={user}
      altLogo={true}
      reactRouterLink={Link}
      hideFooter={true}
    >
      {children}
    </AppLayoutContainer>
  );
};
